import {Platform} from 'react-native';

import VisitWebsitePopover from '/component/partial/VisitWebsitePopover';
import {openURL, openURLInNewTabOnWeb} from '/util/linking.util';

import {
  GenerateOnLearnMoreParams,
  GenerateOnLearnMoreReturnParams,
} from './BusinessBuilderBonusBanner.types';

export const generateOnLearnMore = ({
  popoverShow = () => {},
  currentScreen = '',
}: GenerateOnLearnMoreParams): GenerateOnLearnMoreReturnParams => {
  const destinationURL =
    'https://coachanswers.optavia.com/help/s/article/Business-Builder-Bonus?language=en_US';
  return () => {
    if (Platform.OS === 'web') {
      openURLInNewTabOnWeb(destinationURL);
      return;
    }

    popoverShow(VisitWebsitePopover, {
      currentScreen: currentScreen,
      destinationURL,
      onSubmit: () => openURL('url', destinationURL),
    });
  };
};
